<template lang="pug">    
  v-row(no-gutters)
    v-col(cols=12)
      v-row.mt-3(no-gutters)
        v-col(cols='12')
          n-datepicker-range(
            :date-range='dateRange'
            :type="'month'"
            :range='false'
            @setDateRange='setDateRange'
          )
      v-row.mt-3(no-gutters)
        v-col(cols='12')
          v-simple-table(fixed-header)
            template(v-slot:default='')
              thead
                tr
                  th.text-left {{ $t('date') }}
                  th.text-left {{ $t('type') }}
                  th.text-left {{ $t('amount-first-step-stake') }}
                  th.text-left
                    | ยอดแทง ชั้นที่ 2
                  //
                    <th class="text-left">
                    ยอดแทง ชั้นที่ 2
                    </th>
                  th.text-left {{ $t('affiliate-income-first-step') }}
                  th.text-left
                    | รายได้แนะนำ ชั้นที่ 2
                  //
                    <th class="text-left">
                    รายได้แนะนำ ชั้นที่ 2
                    </th>
              tbody
                tr(v-for='(item,i) in income', :key='i')
                  td.pt-3 {{ item.date }}
                  td.pt-3
                    p {{ $t('lotto') }}:
                    p {{ $t('casino') }}:
                    p {{ $t('ball') }}:
                    p {{ $t('slot') }}:
                    p {{ $t('powerball') }}:
                  td.pt-3
                    p {{ item.sum_lottery_stake_amount_layer_one | currency }}
                    p {{ item.sum_casino_stake_amount_layer_one | currency }}
                    p {{ item.sum_football_stake_amount_layer_one | currency }}
                    p {{ item.sum_slot_stake_amount_layer_one | currency }}
                    p {{ item.sum_powerball_stake_amount_layer_one | currency }}
                  td.pt-3
                    p {{ item.sum_lottery_stake_amount_layer_two | currency }}
                    p {{ item.sum_casino_stake_amount_layer_two | currency }}
                    p {{ item.sum_football_stake_amount_layer_two | currency }}
                    p {{ item.sum_slot_stake_amount_layer_two | currency }}
                    p {{ item.sum_powerball_stake_amount_layer_two | currency }}
                  //
                    <td class="pt-3">
                    <p>{{ item.sum_lottery_stake_amount_layer_two || '' }}</p>
                    <p>{{ item.sum_casino_stake_amount_layer_two || '' }}</p>
                    <p>{{ item.sum_football_stake_amount_layer_two || '' }}</p>
                    <p>{{ item.sum_slot_stake_amount_layer_two || '' }}</p>
                    </td>
                  td.green--text.pt-3
                    p {{ item.sum_lottery_commission_amount_layer_one | currency }}
                    p {{ item.sum_casino_commission_amount_layer_one | currency }}
                    p {{ item.sum_football_commission_amount_layer_one | currency }}
                    p {{ item.sum_slot_commission_amount_layer_one | currency }}
                    p {{ item.sum_powerball_commission_amount_layer_one | currency }}
                  //
                    <td class="green--text pt-3">
                    <p>{{ item.sum_lottery_commission_amount_layer_two || '' }}</p>
                    <p>{{ item.sum_casino_commission_amount_layer_two || '' }}</p>
                    <p>{{ item.sum_football_commission_amount_layer_two || '' }}</p>
                    <p>{{ item.sum_slot_commission_amount_layer_two || '' }}</p>
                    </td>
                  td.green--text.pt-3
                    p {{ item.sum_lottery_commission_amount_layer_two | currency }}
                    p {{ item.sum_casino_commission_amount_layer_two | currency }}
                    p {{ item.sum_football_commission_amount_layer_two | currency }}
                    p {{ item.sum_slot_commission_amount_layer_two | currency }}
                    p {{ item.sum_powerball_commission_amount_layer_two | currency }}
                tr(v-if='income.length!==0')
                  td {{ $t('sum') }}
                  td
                  td {{ summary.sum_total_stake_amount_layer_one | currency }}
                  td {{ summary.sum_total_stake_amount_layer_two | currency }}
                  // <td>{{ fixedTwo(summary.sum_total_stake_amount_layer_two) }}</td>
                  td.green--text
                    | {{ summary.sum_total_commission_amount_one | currency }}
                  td.green--text
                    | {{ summary.sum_total_commission_amount_two | currency }}
                  //
                    <td class="green--text">
                    {{ fixedTwo(summary.sum_total_commission_amount_two) }}
                    </td>
          v-card.pb-5.bgEmpty(v-if='income.length===0', flat)
            n-empty

</template>
<script>   
import { affiliate as apiAffiliate } from '@/apis' 

export default { 
  data: () => ({
    income:[],
    summary:null,
    dateRange : ['','']
  }),  
  computed: {
    version () {
      return process.env.VUE_APP_ENV
    }
  },
  methods : {  
    setDateRange (value) { 
      this.dateRange = value
      if(this.dateRange[1]!==''){
      this.$ga.event('Button', 'SelectDateRange', 'AffiliatePage','')
        this.load()
      } 
    },
    async load (params = {}) {
      params = {
        start_date : this.dateRange[0],
        end_date : this.dateRange[1],
        version : this.version
      }
      const [err,data] = await apiAffiliate.getCommissionHistory(params) 

      if(err) {
        this.$alert('',err,'warning')  
        return
      } 

      this.income = data.history || []
      this.summary = data.summary || {}
    }
  }
}
</script> 